<template>
  <section>
    <v-container class="container-custom">
      <v-row>
        <v-col md="12">
          <div class="titleAction">
            <h1 class="systemTitle">Advertisement</h1>
            <router-link to="/business/addBanner"
              ><v-btn large>
                <v-icon class="mr-2"> mdi-plus </v-icon> Add
                Advertisement</v-btn
              ></router-link
            >
          </div>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="greenBack">
                  <th class="text-left">Image</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">Action</th>
                </tr>
              </thead>
              <tbody v-if="!loading">
                <tr
                  v-for="(data, index) in advertisement"
                  :key="index + 'product'"
                  class="rowBox"
                >
                  <td width="120">
                    <img :src="data.imageWeb" alt="" width="100" />
                  </td>
                  <td>{{ data.title }}</td>
                  <td width="10">
                    <div class="d-flex">
                      <router-link :to="`/business/addBanner/${data._id}`"
                        ><v-icon> mdi-square-edit-outline </v-icon></router-link
                      >
                      <v-icon
                        class="ml-3"
                        v-if="!loadingDelete || id != data._id"
                        @click="removeAdvertisement(data._id)"
                      >
                        mdi-delete
                      </v-icon>
                      <v-progress-circular
                        class="ml-3"
                        indeterminate
                        v-if="loadingDelete && id == data._id"
                        size="20"
                        width="2"
                      ></v-progress-circular>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="loading">
                <tr>
                  <td>
                    Loading
                    <v-progress-circular
                      indeterminate
                      size="20"
                      width="2"
                      class="ml-2"
                    ></v-progress-circular>
                  </td>
                </tr>
              </tbody>

              <tfoot v-if="!loading">
                <tr>
                  <td colspan="5">
                    <ul class="pagination">
                      <li v-if="pagination.previous">
                        <v-icon @click="prev(pagination.previous)">
                          mdi-chevron-left
                        </v-icon>
                      </li>
                      <li>
                        <span v-if="pagination.previous && !pagination.next"
                          >{{
                            pagination.previous + 1 > 1
                              ? pagination.previous + 1 * limit
                              : 1
                          }}
                          -</span
                        >
                        <span v-if="pagination.previous && pagination.next"
                          >{{
                            pagination.previous + 1 > 1
                              ? pagination.previous + 1 * limit
                              : 1
                          }}
                          -</span
                        >
                        <span v-if="pagination.next && !pagination.previous"
                          >{{
                            pagination.next - 1 > 1
                              ? pagination.next - 1 * limit
                              : 1
                          }}
                          -</span
                        >
                        {{ pagination.total }} Items
                      </li>
                      <li v-if="pagination.next">
                        <v-icon @click="next(pagination.next)">
                          mdi-chevron-right
                        </v-icon>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table></v-col
        >
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Blog",
  data: () => ({
    advertisement: [],
    loading: true,
    loadingDelete: false,
    pagination: undefined,
    limit: 10,
    page: 1,
    id: undefined,
  }),
  computed: {
    ...mapGetters(["allAdvertisements"]),
  },
  methods: {
    ...mapActions(["getAdvertisement","deleteAdvertisements"]),
    async removeAdvertisement(id) {
      this.loadingDelete = true;
      this.id = id;
      await this.deleteAdvertisements(id);
      this.loadingDelete = false;
      this.advertisement = this.allAdvertisements.results;
      this.pagination = this.allAdvertisements.pagination;
    },
    async next(data) {
      this.loading = true;
      await this.getAdvertisement({ limit: this.limit, page: data });
      this.advertisement = this.allAdvertisements.results;
      this.pagination = this.allAdvertisements.pagination;
      this.loading = false;
    },
    async prev(data) {
      this.loading = true;
      await this.getAdvertisement({ limit: this.limit, page: data });
      this.advertisement = this.allAdvertisements.results;
      this.pagination = this.allAdvertisements.pagination;
      this.loading = false;
    },
  },
  async created() {
    await this.getAdvertisement({ limit: this.limit, page: this.page });
    this.advertisement = this.allAdvertisements.results;
    this.pagination = this.allAdvertisements.pagination;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
.pagination {
  list-style: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .v-icon {
    font-size: 18px;
    height: 30px;
    width: 30px;
    display: flex;
  }
}
.titleAction {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  a {
    text-decoration: none;
  }
}
.rowBox {
  td {
    padding: 10px !important;
  }
}
</style>